"use client";

import * as React from "react";
import { CircularProgress } from "@mui/material";
import { useLocation, useNavigate, useMatch } from "react-router-dom";
import { useUser } from "../../contextApi/UserContext";
import routes from "../../routes";
import { apiService } from "../../services/Service";
import { getNavigationItems } from "./navigationConfig";
import { DashboardLayout } from "./dashboard-layout";

function DemoPageContent({ pathname }: { pathname: string }) {
  // Match dynamic routes using useMatch for update pages
  const matchUpdateProblem = useMatch("/problem/update/:id");
  const matchUpdateClient = useMatch("/admin/client/update/:id");
  const mathchUserProfile = useMatch("/admin/user/:id");
  const matchUpdateMCQ = useMatch("/mcq/update/:id");
  const matchDetailsMCQ = useMatch("/mcq/details/:id");
  const matchUpdateAssessment = useMatch("/assessments/update/:id");
  const matchAssessmentReport = useMatch("/assessments/report/:id");
  const matchUserAssessmentReport = useMatch(
    "/assessments/report/:id/user/:userId",
  );
  const matchUpdatePlan = useMatch("/plans/update/:id");
  const matchedTags = useMatch("/tags/update/:id");
  const matchUpdateTags = useMatch("/companyTags/update/:id");
  const matchedReviewMcq = useMatch("/mcq/review/:id");
  const matchUpdateSection = useMatch("/client/sections/update/:id");
  const matchUpdatePattern = useMatch("/client/patterns/update/:id");
  const matchUpdateAssessmentV2 = useMatch("/client/assessmentsv2/update/:id");
  const matchedReviewMcqV2 = useMatch(
    "/mcq-problems/assign-moderator/review/:id",
  );
  const matchedReviewCodingProblem = useMatch(
    "/coding-problems/assign-moderator/review/:id",
  );
  const matchDetailsProblem = useMatch("/problem/details/:id");
  const matchAssessmentUsers = useMatch("/client/assessmentsv2/users/:id");
  const matchAssessmentUserReport = useMatch(
    "/client/assessmentsv2/:assessmentId/user/:userId/report",
  );
  const matchCodingProblemViewer = useMatch("/coding-problems/view/:id");
  const matchStudentListForAssessment = useMatch(
    "/assessment-monitoring/students/:assessmentId",
  );
  const matchLiveMontior = useMatch(
    "/assessment-monitoring/live-monitor/:attemptId",
  );

  const applyForJob = useMatch("/apply-job/:jobId");
  const applyForCareerJob = useMatch("/apply-career-job/:jobId");

  const AgencyManageApplicants = useMatch("/agency/manage-applicants/:jobId");
  const BulkAddApplicants = useMatch("/agency/job-bulk-add-applicants/:jobId");

  const matchApplicantsFitmentAnalysis = useMatch(
    "/agency/applicants-analysis/:studentId",
  );

  const matchUnifiedQuestionUpdate = useMatch("/author/questions/edit/:id");

  const matchUnifiedQuestionDetails = useMatch("/author/questions/details/:id");
  return (
    <>
      {matchCodingProblemViewer && <routes.CodingProblemViewer />}

      {!matchCodingProblemViewer && (
        <div className="p-6">
          {(pathname === "/" && <routes.ProfileDashboard />) ||
            (pathname === "/privacy-policy" && <routes.PrivacyPolicy />) ||
            (pathname === "/terms-of-service" && <routes.TermsOfService />) ||
            (pathname === "/cookie-policy" && <routes.CookiePolicy />) ||
            (pathname === "/refund-policy" && <routes.RefundPolicy />) ||
            (pathname === "/profile" && <routes.ProfileDashboard />) ||
            (pathname === "/users" && <routes.UserManagement />) ||
            (pathname === "/users/create" && <routes.CreateUser />) ||
            (pathname === "/coding-problems/create" && (
              <routes.CreateProblem />
            )) ||
            (pathname === "/coding-problems" && <routes.Problems />) ||
            (pathname === "/coding-problems/ai" && <routes.AiProblems />) ||
            (pathname === "/coding-problems/ai/create" && (
              <routes.CreateAiCoding />
            )) ||
            (pathname === "/admin-sections" && <routes.AdminSections />) ||
            (pathname === "/mcq-problems/create" && <routes.CreateMCQ />) ||
            (pathname === "/mcq-problems" && <routes.MCQs />) ||
            (pathname === "/mcq-problems/ai" && <routes.AiMCQs />) ||
            (pathname === "/mcq-problems/ai/create" && (
              <routes.CreateAiMCQ />
            )) ||
            (pathname === "/clients/create" && <routes.CreateClient />) ||
            (pathname === "/clients" && <routes.ClientList />) ||
            (pathname === "/client/details" && <routes.ClientDetails />) ||
            (pathname === "/client/users" && <routes.ClientUserManagement />) ||
            (pathname === "/client/assessments" && <routes.Assessments />) ||
            (pathname === "/client/user-groups" && (
              <routes.UserGroupManagement />
            )) ||
            (pathname === "/client/create-groups" && <routes.CreateGroups />) ||
            (pathname === "/client/create-group-users" && (
              <routes.CreateGroupUsers />
            )) ||
            (pathname === "/client/create-users" && (
              <routes.CreateUsersTabs />
            )) ||
            (pathname === "/client/assessments/create" && (
              <routes.CreateAssessment />
            )) ||
            (pathname === "/client/assessmentsv2/create" && (
              <routes.CreateAssessmentV2 />
            )) ||
            (pathname === "/client/assessmentsv2" && (
              <routes.AssessmentsV2 />
            )) ||
            (pathname === "/client/assessmentsv2/launchAssessment" && (
              <routes.LaunchAssessmentV2 />
            )) ||
            (pathname === "/client/assessmentsv2/scheduleAssessment" && (
              <routes.ScheduleAssessmentV2 />
            )) ||
            (pathname === "/client/assessmentsv2/runningAssessment" && (
              <routes.RunningAssessmentsV2 />
            )) ||
            (pathname === "/assessments" && <routes.Assessments />) ||
            (pathname === "/client/sections" && <routes.Sections />) ||
            (pathname === "/client/sections/create" && (
              <routes.CreateSection />
            )) ||
            (pathname === "/client/patterns" && <routes.Patterns />) ||
            (pathname === "/client/patterns/create" && (
              <routes.CreatePattern />
            )) ||
            (pathname === "/assessments/create" && (
              <routes.CreateAssessment />
            )) ||
            (pathname === "/plans" && <routes.ManagePlans />) ||
            (pathname === "/plans/create" && <routes.CreatePlan />) ||
            (pathname === "/tags" && <routes.Tags />) ||
            (pathname === "/tags/create" && <routes.Createtags />) ||
            (pathname === "/companyTags" && <routes.companyTags />) ||
            (pathname === "/companyTags/create" && (
              <routes.CreateCompanyTags />
            )) ||
            (pathname === "/mcq-problems/review" && <routes.ReviewMcqs />) ||
            (pathname === "/mcq-problems/assign-moderator" && (
              <routes.ModeratorDashboard />
            )) ||
            (pathname === "/coding-problems/assign-moderator" && (
              <routes.CodingModeratorDashboard />
            )) ||
            (pathname === "/work-tracker" && <routes.AuthorContributions />) ||
            (pathname === "/plans/:planId/signup" && <routes.StudentForm />) ||
            (pathname === "/plans/:planId/organization-type" && (
              <routes.OrganizationTypePage />
            )) ||
            (pathname === "/plans/:planId/institution" && (
              <routes.InstitutionForm />
            )) ||
            (pathname === "/plans/:planId/company" && <routes.CompanyForm />) ||
            (pathname === "/payment" && <routes.PaymentPage />) ||
            (pathname === "/loginPlan" && <routes.LoginPlan />) ||
            (pathname === "/email-login" && <routes.EmailLogin />) ||
            (pathname === "/signup-success" && <routes.SuccessPage />) ||
            (pathname === "/payment-success" && <routes.SuccessPage />) ||
            (pathname === "/contact-sales-dashboard" && (
              <routes.ContactSalesDashboard />
            )) ||
            (pathname === "/request-demo-dashboard" && (
              <routes.RequestDemoDashboard />
            )) ||
            (pathname === "/author-management/summary" && (
              <routes.AuthorManagementSummary />
            )) ||
            (pathname === "/client/reports/assessment-wise" && (
              <routes.AssessmentWiseUserReport />
            )) ||
            (pathname === "/client/reports/user-group-wise" && (
              <routes.UserGroupWiseReport />
            )) ||
            (pathname === "/client/reports/student-wise" && (
              <routes.StudentWiseReport />
            )) ||
            (pathname === "/client/reports/custom-assessment" && (
              <routes.CustomAssessmentReport />
            )) ||
            (pathname === "/client/reports/client-wise" && (
              <routes.ClientWiseReport />
            )) ||
            (pathname === "/client/reports/make-my-report" && (
              <routes.MakeMyReport />
            )) ||
            (pathname === "/fitment-analysis/content-fitment-analysis" && (
              <routes.ContentFA />
            )) ||
            (pathname === "/fitment-analysis/company-fitment-analysis" && (
              <routes.CompanyFA />
            )) ||
            (pathname === "/fitment-analysis/job-role-fitment-analysis" && (
              <routes.JobRoleFA />
            )) ||
            (pathname === "/fitment-analysis/job-roles-topic" && (
              <routes.JobRolesTopic />
            )) ||
            (pathname === "/coding-problems/csv-upload" && (
              <routes.CreateCsvProblem />
            )) ||
            (pathname === "/coupon-management" && <routes.ViewCoupons />) ||
            (pathname === "/coupon-management/create-coupon" && (
              <routes.CreateCoupon />
            )) ||
            (pathname === "/report-questions" && <routes.QuestionReports />) ||
            (pathname === "/mcq-problems/csv-upload" && (
              <routes.CreateCsvMcq />
            )) ||
            (pathname === "/question-bank-overview/mcq" && (
              <routes.McqBankOverview />
            )) ||
            (pathname === "/signup-success" && <routes.SignupSuccessPage />) ||
            (pathname === "/question-bank-overview/coding" && (
              <routes.CodingBankOverview />
            )) ||
            (pathname === "/leaderboard" && <routes.LeaderboardPage />) ||
            (pathname === "/company-registration" && (
              <routes.CompanyRegistration />
            )) ||
            (pathname === "company" && <routes.CompanyLayout />) ||
            (pathname === "/company/dashboard" && <routes.CompanyOverview />) ||
            (pathname === "/company/post-job" && <routes.PostJob />) ||
            (pathname === "/company/edit-job" && <routes.EditJob />) ||
            (pathname === "/company/applicants" && <routes.ApplicantsView />) ||
            (pathname === "/company/leaderboard" && (
              <routes.JobLeaderboard />
            )) ||
            (pathname === "/company/settings" && <routes.CompanySettings />) ||
            (pathname === "/onboarded-companies" && (
              <routes.OnboardedCompanies />
            )) ||
            (pathname === "/career-management/post-job" && (
              <routes.CareerJobPost />
            )) ||
            (pathname === "/view-jobs" && <routes.ViewJobs />) ||
            (pathname === "/view-career-jobs" && <routes.ViewCareerJobs />) ||
            (pathname === "/apply-career-job/:jobId" && (
              <routes.ApplyCareerJob />
            )) ||
            (pathname === "/career-management/view-jobs" && (
              <routes.AdminViewJobs />
            )) ||
            (pathname === "/career-management/view-applicants" && (
              <routes.AdminViewApplicants />
            )) ||
            (pathname === "/agency/share-job-report" && (
              <routes.ShareJobReport />
            )) ||
            (pathname === "/student/dashboard" && (
              <routes.StudentDashboard />
            )) ||
            (pathname === "/hire-us" && <routes.HireUs />) ||
            (pathname === "/recruitment/view-agencies" && (
              <routes.ViewAgencies />
            )) ||
            (pathname === "/recruitment/create-agency" && (
              <routes.CreateAgency />
            )) ||
            (pathname === "/client/view-employers" && (
              <routes.ViewEmployers />
            )) ||
            (pathname === "/client/add-employers" && <routes.AddEmployer />) ||
            (pathname === "/client/view-applicants-jobs" && (
              <routes.ViewApplicantsJobs />
            )) ||
            (pathname === "/students/agency-linked" && (
              <routes.AgencyLinkedStudents />
            )) ||
            (pathname === "/students/college-linked" && (
              <routes.CollegeLinkedStudents />
            )) ||
            (pathname === "/students/individuals" && (
              <routes.IndividualsLinkedStudents />
            )) ||
            (pathname === "/client/view-candidates" && (
              <routes.ViewCandidates />
            )) ||
            (pathname === "/client/add-candidates" && (
              <routes.AddCandidates />
            )) ||
            (pathname === "/agency/post-job" && <routes.AgencyPostJob />) ||
            (pathname === "/student/jobsManagement" && (
              <routes.StudentJobsManagement />
            )) ||
            (pathname === "/agency/manage-jobs" && (
              <routes.AgencyJobsManagement />
            )) ||
            (pathname === "/company/agency-drives" && (
              <routes.AgencyJobsForCompany />
            )) ||
            (pathname === "/agency/edit-job" && <routes.AgencyEditJob />) ||
            // (pathname === "/agency/manage-applicants/:jobId" && <routes.AgencyManageApplicants />) ||
            // (pathname === "/agency/job-bulk-add-applicants/:jobId" && <routes.BulkAddApplicants />) ||

            (pathname === "/author/unified-question-creator" && (
              <routes.CreateUnifiedProblem />
            )) ||
            (pathname === "/author/csv-upload" && (
              <routes.CSVUploadUnified />
            )) ||
            (pathname === "/author/csv-upload-history" && (
              <routes.CSVUploadHistory />
            )) ||
            (pathname === "/author/questions" && (
              <routes.UnifiedQuestionBank />
            )) ||
            (pathname === "/moderator/questions" && (
              <routes.UnifiedModeratorDashboard />
            )) ||
            (pathname === "/admin/question-bank-overview" && (
              <routes.QuestionBankOverview />
            )) ||
            // (pathname === "/admin/author-management" && (
            //   <routes.AuthorManagement />
            // )) ||
            (pathname === "/author-management/add-author" && (
              <routes.AddAuthor />
            )) ||
            (pathname === "/author-management/add-moderator" && (
              <routes.AddModerator />
            )) ||
            (pathname === "/author-management/add-content-head" && (
              <routes.AddContentHead />
            )) ||
            (pathname === "/author-management/add-super-access" && (
              <routes.AddSuperAccess />
            )) ||
            (pathname === "/author-management/view-authors" && (
              <routes.ViewAuthor />
            )) ||
            (pathname === "/author-management/view-moderator" && (
              <routes.ViewModerator />
            )) ||
            (pathname === "/author-management/view-content-head" && (
              <routes.ViewContentHead />
            )) ||
            (pathname === "/author-management/view-super-access" && (
              <routes.ViewSuperAccess />
            )) ||
            (pathname === "/super-admin/view-consultants" && (
              <routes.ViewConsultants />
            )) ||
            (pathname === "/super-admin/add-consultants" && (
              <routes.AddConsultants />
            )) ||
            (pathname === "/super-admin/view-business-units" && (
              <routes.ViewBusinessUnits />
            )) ||
            (pathname === "/super-admin/add-business-unit" && (
              <routes.AddBusinessUnit />
            )) ||
            (pathname === "/super-admin/assign-consultants" && (
              <routes.AssignConsultantsToBU />
            )) ||
            (pathname === "/business-unit/view-consultants" && (
              <routes.ViewConsultantsToBU />
            )) ||
            (pathname === "/business-unit/add-consultants" && (
              <routes.AddConsultantsToBU />
            )) ||
            (pathname === "/business-unit/assign-consultants" && (
              <routes.AssignConsultants />
            )) ||
            (pathname === "/super-admin/add-group" && (
              <routes.SuperAdminAddGroup />
            )) ||
            (pathname === "/super-admin/view-groups" && (
              <routes.SuperAdminViewGroups />
            )) ||
            (pathname === "/super-admin/assign-group-consultants" && (
              <routes.BUAssignGroupConsultants />
            )) ||
            (pathname === "/business-unit/group-management" && (
              <routes.BUGroupsManagement />
            )) ||
            (pathname === "/super-admin/summary-report" && (
              <routes.SuperAdminReportsSummary />
            )) ||
            (pathname === "/super-admin/business-unit-wise-report" && (
              <routes.SuperAdminBusinessUnitWiseReport />
            )) ||
            (pathname === "/author-management/view-enterprise-admin" && (
              <routes.ViewEnterpriseAdmin />
            )) ||
            (pathname === "/author-management/add-enterprise-admin" && (
              <routes.AddEnterpriseAdmin />
            )) ||
            (pathname === "/author-management/review-licenses" && (
              <routes.AdminReviewLicenses />
            )) ||
            (pathname === "/enterprise-admin/view-licenses" && (
              <routes.ViewLicenseRequests />
            )) ||
            (pathname === "/enterprise-admin/add-licenses" && (
              <routes.AddLicenseRequest />
            )) ||
            
         
            (pathname === "/global-jobs-management/view-jobs" && (
              <routes.AdminGlobalJobManagement />
            )) ||
            (pathname === "/author/codingToDebuggingStudio" && (
              <routes.CodingToDebuggingStudio />
            )) ||
            // Matchers
            (matchedTags && <routes.Updatetags />) ||
            (matchUpdateTags && <routes.UpdateCompanyTags />) ||
            (matchUpdateSection && <routes.UpdateSection />) ||
            (matchUpdatePattern && <routes.UpdatePattern />) ||
            (matchedReviewMcq && <routes.ReviewMcq />) ||
            (mathchUserProfile && <routes.UserPage />) ||
            (matchUpdatePlan && <routes.UpdatePlan />) ||
            (matchUpdateProblem && <routes.UpdateProblem />) ||
            (matchUpdateClient && <routes.UpdateClient />) ||
            (matchUpdateMCQ && <routes.UpdateMCQ />) ||
            (matchDetailsMCQ && <routes.MCQDetails />) ||
            (matchUpdateAssessmentV2 && <routes.UpdateAssessmentV2 />) ||
            (matchUserAssessmentReport && <routes.UserAssessmentReport />) ||
            (matchUpdateAssessment && <routes.UpdateAssessment />) ||
            (matchedReviewMcqV2 && <routes.ModeratorReviewPage />) ||
            (matchedReviewCodingProblem && (
              <routes.CodingModeratorReviewPage />
            )) ||
            (matchDetailsProblem && <routes.ProblemDetails />) ||
            (matchAssessmentUsers && <routes.AssessmentUsers />) ||
            (matchAssessmentUserReport && <routes.AssessmentUserReport />) ||
            (matchLiveMontior && <routes.LiveMonitor />) ||
            (applyForJob && <routes.ApplyJob />) ||
            (applyForCareerJob && <routes.ApplyCareerJob />) ||
            (AgencyManageApplicants && <routes.AgencyManageApplicants />) ||
            (BulkAddApplicants && <routes.BulkAddApplicants />) ||
            (matchApplicantsFitmentAnalysis && (
              <routes.ApplicantsFitmentAnalysis />
            )) ||
            (matchStudentListForAssessment && (
              <routes.StudentListForAssessment />
            )) ||
            (matchUnifiedQuestionUpdate && <routes.UnifiedQuestionUpdate />) ||
            (matchUnifiedQuestionDetails && <routes.UnifiedQuestionDetail />)}
        </div>
      )}
    </>
  );
}

interface DemoProps {
  window?: () => Window;
}

export default function DashboardLayoutBasic(props: DemoProps) {
  const [loading, setLoading] = React.useState<boolean>(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, setUser } = useUser();
  const [session, setSession] = React.useState<any>(null);
  const [navigationItems, setNavigationItems]: any = React.useState([]);
  const matchCodingProblemViewer = useMatch("/coding-problems/view/:id");

  const handleSignOut = () => {
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("user");

    setSession(null);
    navigate("/login");
  };

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const fetchProfile = async () => {
    try {
      const response: any = await apiService.get("/user/profile");
      setSession({
        user: {
          name: response.user.fullname,
          email: response.user.email,
          image: response.user.picture,
          role: response.user.role, // ✅ Added
          accountType: response.user.accountType, // ✅ Added
        },
      });
      setUser(response.user);
      console.log("response.user: ", response.user);
      if (response.user.role) {
        // 👇 PASS THE FULL USER OBJECT HERE
        setNavigationItems(
          getNavigationItems(response.user.role, response.user),
        );
      }
      if (response.user.role) {
        setNavigationItems(getNavigationItems(response.user.role));
      }
    } catch (err: any) {
      console.error("Error fetching profile data:", err);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchProfile();
  }, []);

  if (loading)
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <CircularProgress />
      </div>
    );

  // --- ⭐ LAYOUT SWITCHING LOGIC ⭐ ---

  // 1. Fullscreen View (No sidebar) for Coding Problems
  if (matchCodingProblemViewer) {
    return (
      <div className="w-full h-screen overflow-hidden bg-gray-50">
        <DemoPageContent pathname={location.pathname} />
      </div>
    );
  }

  // 2. Company Layout (For users with role 'company')
  // FIX: Cast role to string (or any) to bypass strict Enum check
  if ((user?.role as string) === "company") {
    return (
      <routes.CompanyLayout>
        <DemoPageContent pathname={location.pathname} />
              {/* <Outlet />  */}

      </routes.CompanyLayout>
    );
  }

  // 3. Default Admin/Student Layout
  return (
    <DashboardLayout
      navigation={navigationItems}
      currentPath={location.pathname}
      onNavigate={handleNavigate}
      user={session?.user}
      onSignOut={handleSignOut}
    >
      <DemoPageContent pathname={location.pathname} />
            {/* <Outlet />  */}

    </DashboardLayout>
  );
}
